export default __webpack_public_path__ + "static/anthony-520a0106566e84d713eb73d03074c423.jpg";